export default __webpack_public_path__ + "static/media/smoke-test.fcbbb6ea.svg";